import FileUploadUntyped from './index';

export type FileUploadProps = {
  name?: string;
  onFinish: (onFinishProps: { publicUrl: string }) => void;
  fixed?: boolean;
  withCrop?: boolean;
  cropRatio?: number;
  acceptedTypes?: string | string[];
  maxSize?: number;
  quality?: number;
  contentDisposition?: string;
  isZoomable?: boolean;
  uploadCta?: string;
  s3Acl?: 'private' | 'public-read';
  s3Bucket?: 'primary' | 'secure';
  // actions: This gets added by Redux, don't include it here
};

export const FileUpload: (props: FileUploadProps) => JSX.Element | null = FileUploadUntyped;
